import { InferType, number, object } from 'yup';
import { Nullable } from '../../../model/common';
import { safeString } from './common';

interface ClosePositionSchemaParams {}

export const closePositionSchema = (params: ClosePositionSchemaParams) => {
    return object({
        quantity: number().required('Quantity cannot be empty!').typeError('Please input a number.'),
        duration: object({ label: safeString(), value: number() }).required('Duration cannot be empty!')
    });
};

type ClosePositionSchema = ReturnType<typeof closePositionSchema>;
export type ClosePositionFormValues = InferType<ClosePositionSchema>;
export type ClosePositionFormInput = Nullable<ClosePositionFormValues>;
